'use client';

import type { ReactNode } from 'react';

type Props = { href: string; promoId: string; promoName: string; slot: string; className?: string; target?: string; rel?: string; children: ReactNode };

/** Gewone link die een GA4 `select_promotion`-event meestuurt; consent regelt gtag zelf. */
export function PromoClickLink({ href, promoId, promoName, slot, className, target, rel, children }: Props) {
  return (
    <a
      href={href}
      className={className}
      target={target}
      rel={rel}
      onClick={() => {
        try {
          const gtag = (window as unknown as { gtag?: (...args: unknown[]) => void }).gtag;
          gtag?.('event', 'select_promotion', { promotion_id: promoId, promotion_name: promoName, creative_slot: slot });
        } catch {
          // Meten mag een klik nooit tegenhouden.
        }
      }}
    >
      {children}
    </a>
  );
}
